import { defineComponent } from 'vue';
import './TextInput.scss';
export default defineComponent({
    name: 'TextInput',
    props: {
        modelValue: {
            type: String,
            required: true
        },
        size: {
            type: String,
            required: false,
            default: ''
        },
        password: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: () => ({
        value: ''
    }),
    computed: {
        classes() {
            const classList = ['form-control'];
            if (this.size)
                classList.push(`form-control-${this.size}`);
            return classList;
        }
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(value) {
                this.value = value;
            }
        },
        value(value) {
            this.$emit('update:modelValue', value);
        }
    },
    methods: {
        onBlur() {
            this.$emit('blur');
        }
    }
});
